import { MouseEvent, FocusEvent } from 'react';

/* eslint-disable import/prefer-default-export */
export const openLinkOnEvent = (
  e: Event | MouseEvent | FocusEvent,
  url: string,
  target: '_blank' | '_parent' | '_self' | '_top' = '_blank'
) => {
  window.open(url, target);

  e.stopPropagation();
};
